const staticFilesUri = import.meta.env.VITE_STATIC_FILES_URL;

export const prefixWithStaticFilesUri = (uri: string) => `${staticFilesUri}${uri}`;
